import { MenuItem } from "./menu-item"
import useAnimationStore from "../stores/use-animation"
import { useModalStore } from "../stores/use-modal"
export default function Menu () {
  const { startEffect} = useAnimationStore()
  const handleStart = () => {
    startEffect()
  }
  const { openModal} = useModalStore()
  return (
    <div className="font-[Pacifico] text-gold text-2xl space-y-4 z-10">
      <MenuItem title={"Bắt đầu"} onClick={handleStart}/>
      <MenuItem title={"Hướng dẫn"} onClick={() => openModal()}/>
    </div>
  )
}
